import { render } from "./GradeCard.vue?vue&type=template&id=578f7f17"
import script from "./GradeCard.vue?vue&type=script&lang=js"
export * from "./GradeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__